import { Link } from 'react-router-dom';

const ListItems = ({ imgSrc, linkItem, name, isVisible = 'true', pSym }) => {
  if (!isVisible) return <></>;
  return (
    <>
      <li className="box">
        <Link to={linkItem}>
          {imgSrc && <img src={imgSrc} />}
          {pSym && <p style={{ fontSize: '30pt', margin: '0' }}>{pSym}</p>}
          <p> {name} </p>
        </Link>
      </li>
    </>
  );
};
export default ListItems;
